import { List } from "@snapchat/snap-design-system";
import { useCallback } from "react";
import { type FC } from "react";
import { LenssourceModelLensSourceType as LensSourceType } from "../../../gql-generated/types";
import { type SourceModel, type ViewSourceModel } from "../models";
import { LensSourcesListByType } from "./LensSourcesListByType";

interface SourcesGroupProps {
    sources: readonly SourceModel[];
    type: LensSourceType;
    onDelete: (source: ViewSourceModel) => void;
}

export const SourcesGroup: FC<SourcesGroupProps> = ({ sources, onDelete, type }) => {
    const handleDelete = useCallback(
        (source: SourceModel) => {
            onDelete({ ...source, type: type });
        },
        [onDelete, type],
    );

    return (
        <List innerBorder={true} outerBorder={false}>
            {sources.map((source, index) => (
                <List.Item key={source.id}>
                    <LensSourcesListByType
                        lensSource={source}
                        onDelete={handleDelete}
                        isFirst={index === 0}
                        type={type}
                    />
                </List.Item>
            ))}
        </List>
    );
};
